import { useRef, useState } from 'react';
import { CreateTaskForm } from '../../CreateTaskForm/components/CreateTaskForm';
import { useTaskManager } from '../userTaskManager';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

export function AddTaskButton() {
    const { currentEmpresaId } = useTaskManager()

    const [isOpen, setIsOpen] = useState(false);
    const [modalPosition, setModalPosition] = useState<{ top: number; left: number; width: number; }>({
        top: 0,
        left: 0,
        width: 0,
    });

    const buttonRef = useRef<HTMLDivElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);

    const onToggleModal = () => {
        if(buttonRef.current) {
            setModalPosition({
                top: buttonRef.current.offsetHeight + 20,
                left: buttonRef.current.offsetLeft,
                width: buttonRef.current.offsetWidth,
            });
        }

        setIsOpen(!isOpen);
    }

    return (
    <div>
        <div 
            ref={buttonRef}
            onClick={onToggleModal}
            className="flex items-center border-[1px] border-gray-300 bg-slate-50 hover:bg-slate-200 rounded-md h-10 px-2 ">
            <AddRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 25, width: 25 }}/>
            <p className="font-semibold select-none">Agregar una tarea</p>
        </div>

        {isOpen && (
        <div
            ref={modalRef}
            className="absolute bg-white shadow-lg border border-gray-300 rounded py-3s px-5s z-50"
            style={{ bottom: modalPosition.top, left: modalPosition.left, width: modalPosition.width }}>
            <CreateTaskForm 
                setIsOpen={setIsOpen}
                empresaId={currentEmpresaId} />
        </div>
        )}
    </div>
    );
}
